import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from "rxjs";
import {UserRoles} from "../user/user-roles";
import * as fromStore from '../store';
import {first, switchMap} from "rxjs/operators";
import {DbStoreState} from '../store';
import {Store} from '@ngrx/store';
import {combineLatest} from "rxjs";

@Injectable()
export class SinglePageDemoGuard implements CanActivate {



  constructor(
    private _router: Router,
    private _store: Store<DbStoreState>,
  ) {}

  // TODO check all cases in auth guard (check variable names, functions, statements) handle and remove zendesk part
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    return new Promise<boolean>((resolve) => {
      this._store.select(fromStore.getUserLoaded)
        .pipe(
          first((loaded: boolean) => loaded),
          switchMap(() => combineLatest(
              this._store.select(fromStore.getUser),
              this._store.select(fromStore.getUserSubscription)
            )
          ),
          first()
        )
        .subscribe(([user, userSubscription]) => {
          const role: string = user ? UserRoles.user : UserRoles.guest;
          this._store.select(fromStore.getWebsitesLoaded)
            .pipe(
              first(loaded => loaded),
              switchMap(() => this._store.select(fromStore.getWebsites)),
              first()
            )
            .subscribe(websites => {
              if (websites && websites.length === 1 && userSubscription?.trialClient && window.innerWidth < 991) {
                const demoWebsite = websites.filter(website => website.isAiBuilderDemo);
                if (demoWebsite) {
                  return resolve(true);
                }
                else {
                  this._router.navigate(['/websites']);
                  return resolve(false);
                }
              }
              else {
                this._router.navigate(['/websites']);
                return resolve(false);
              }
            });
        });
    });
  }

}
